<template>
    <el-container>
        <el-header>
            <span>{{$t('setting.taxInfo')}}</span>
        </el-header>

        <el-main>
            <div v-if="loading && !initialDataLoaded" class="setting-initial-loading" v-loading="true"></div>
            <el-alert v-else-if="loadError !== ''" :title="loadError" type="error" :closable="false" show-icon></el-alert>
            <div v-else>
                <!----------------------------------页面内容---------------------------------->
                <el-row>
                    <el-form label-position="left" label-width="160px" ref="form" v-loading="loading" class="taxListform">

                        <el-card class="withholding-tax-card">
                            <el-row>
                                <el-col :span="16" class="biaoti">
                                    <div class="grid-content bg-purple">
                                        <span>{{$t('itemCreate.withholdingTitle')}}</span>
                                    </div>
                                </el-col>
                            </el-row>
                            <el-divider></el-divider>

                            <el-form-item :label="userSetting.withHoldingTaxName+'('+userSetting.withHoldingTaxRate+'%)'">
                                <el-switch v-model="userSetting.withHoldingActive" :active-value=1 :inactive-value=0></el-switch>
                            </el-form-item>

                            <el-form-item :label="$t('setting.rateLabel')">
                                <el-input onfocus="this.select()" inputmode="decimal" v-model="userSetting.withHoldingTaxRate"></el-input>
                            </el-form-item>

                            <el-form-item :label="$t('setting.abbreviation')">
                                <el-input type="text" v-model="userSetting.withHoldingTaxName"></el-input>
                            </el-form-item>

                            <el-button style="margin-left: 1%" @click.native.prevent="updateWithholding" type="success"
                                       :disabled="!initialDataLoaded || loading || !withholdingDirty">{{$t('common.save')}}</el-button>
                        </el-card>


                        <el-card class="taxes-card">
                            <el-row>
                                <el-col :span="16" class="biaoti">
                                    <div class="grid-content bg-purple">
                                        <span>{{$t('setting.taxes')}}</span>
                                    </div>
                                </el-col>
                            </el-row>
                            <el-divider></el-divider>

                            <el-form-item class="taxItemList" :label='taxInfo.taxName' v-for="taxInfo in userTaxInfoList" :key="taxInfo.innerUUID">
                                <el-button class="taxListButton" v-model="taxInfo.rates" @click="openDialog(taxInfo)">
                                    {{taxInfo.firstRate}}
                                </el-button>
                                <el-button class="tax-delete-button" type="text" @click="prepareDeleteTax(taxInfo.innerUUID)">{{$t('common.delete')}}</el-button>
                            </el-form-item>
                                <el-form-item label=''>
                                    <el-button type="text" @click="addTax()">{{$t('setting.addTax')}}</el-button>
                                </el-form-item>
                        </el-card>

                        <el-card class="tax-year-start-card">
                            <el-row>
                                <el-col :span="16" class="biaoti">
                                    <div class="grid-content bg-purple">
                                        <span>{{$t('setting.taxYearStarts')}}</span>
                                    </div>
                                </el-col>
                            </el-row>
                            <el-divider></el-divider>
                            <div class="tax-year-subtitle">{{$t('setting.taxYearStartSubtitle')}}</div>
                            <div class="tax-year-controls">
                                <el-form-item :label="$t('setting.month')">
                                    <el-select v-model="taxYearStartMonth" :placeholder="$t('setting.monthPlaceholder')" @change="changeTaxYearStartMonth">
                                        <el-option
                                                v-for="month in monthOptions"
                                                :key="month.value"
                                                :label="month.label"
                                                :value="month.value"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item :label="$t('setting.day')">
                                    <el-select v-model="taxYearStartDay" :placeholder="$t('setting.dayPlaceholder')">
                                        <el-option
                                                v-for="day in dayOptions"
                                                :key="day.value"
                                                :label="day.label"
                                                :value="day.value"></el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                            <el-button style="margin-left: 1%" @click.native.prevent="updateTaxYearStart" type="success"
                                       :disabled="!initialDataLoaded || loading || !taxYearDirty">{{$t('common.save')}}</el-button>
                        </el-card>
                    </el-form>
                </el-row>
                <!----------------------------------页面内容---------------------------------->


                <el-dialog
                        :title="$t('setting.deleteDialogTitle')"
                        :visible.sync="deleteTaxDialog"
                        append-to-body
                        custom-class="setting-dialog"
                        width="30%">
                    <span>{{$t('setting.confirmDeleteTax')}}</span>
                    <span slot="footer" class="dialog-footer">
                        <el-button @click="deleteTaxDialog = false">{{$t('common.cancel')}}</el-button>
                        <el-button type="primary" :loading="deleteTaxLoading" @click="deleteTax()">{{$t('common.delete')}}</el-button>
                      </span>
                </el-dialog>

                <!----------------------------------弹出框,增加或者修改税信息---------------------------------->
                <el-dialog :title="$t('setting.taxInfoDialogTitle')" :visible.sync="dialogOpen"
                           :before-close="handleTaxDialogClose"
                           append-to-body custom-class="setting-dialog" width="40%">
                    <el-form label-width="200px">
                        <!--税信息-->
                        <el-form-item :label="$t('setting.taxName')">
                            <el-input v-model="taxInfoName"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('setting.standardRate')">
                            <el-input onfocus="this.select()" inputmode="decimal" v-model="standardRate"></el-input>
                        </el-form-item>
                        <el-form-item class="tax_delete" :label="$t('setting.additionalRateNumber', {number: index + 1})"
                                      v-for="(value,index) in userTaxItemList " :key="index">
                            <el-input style="display: inline" onfocus="this.select()" inputmode="decimal" v-model="userTaxItemList[index]"></el-input>
                            <el-button style="margin-left: 5%;color: red" @click="deleteRate(index)" type="text">{{$t('setting.deleteRateX')}}
                            </el-button>
                        </el-form-item>
                        <el-form-item label="">
                            <el-button type="text" @click="addRate()">{{$t('setting.addRate')}}</el-button>
                        </el-form-item>


                        <el-form-item :label="$t('setting.taxType')">
                            <el-radio-group v-model="taxInclusive" size="middle">
                                <el-radio-button :disabled="exclusiveStatus" :label="0">{{$t('setting.exclusive')}}</el-radio-button>
                                <el-radio-button :disabled="inclusiveStatus" :label="1">{{$t('setting.inclusive')}}</el-radio-button>
                            </el-radio-group>
                        </el-form-item>
                    </el-form>
                    <!--弹框的底部标签-->
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="handleTaxDialogClose()">{{$t('setting.close')}}</el-button>
                        <el-button type="primary" @click="saveTaxInfo()" :loading="dialogSaveLoading"
                                   :disabled="dialogSaveLoading || !taxDialogDirty">{{$t('setting.saveTax')}}
                        </el-button>
                    </div>
                </el-dialog>

                <!----------------------------------弹出框,增加或者修改税信息---------------------------------->
                <el-dialog :visible.sync="cantOpenDetail" width="40%"
                           append-to-body custom-class="setting-dialog"
                           :close-on-click-modal="false"
                           :close-on-press-escape="false"
                           :show-close="false">
                    <div style="font-size: 20px;line-height: 2;">
                        {{$t('setting.cantOpenDetailMessage')}}
                    </div>
                    <div slot="footer" class="dialog-footer">
                        <el-button type="primary" @click="cantOpenDetail = false">{{$t('setting.closeButton')}}</el-button>
                    </div>
                </el-dialog>
            </div>
        </el-main>

    </el-container>
</template>

<script>
    import {uuid, timest} from '@/utils/validate'
    import {replaceStoredSetting, syncCompanySelection} from '@/utils/company'
    import {
        percentageToStoredTaxRate,
        storedTaxRateToPercentage
    } from '@/utils/taxInputValidation'

    export default {
        methods: {
            //打开对话框
            openDialog(taxInfo) {

                if (taxInfo.accumulateTaxInfoUUIDArrayKey != '' || taxInfo.beAccumulateTaxInfoUUIDArrayKey != '') {
                    this.cantOpenDetail = true;
                    return;
                }
                this.taxInfoName = taxInfo.taxName;
                this.taxId = taxInfo.taxId;
                this.innerUUID = taxInfo.innerUUID;
                var taxSplit = String(taxInfo.rates == null ? '' : taxInfo.rates)
                    .split("&&").filter(rate => rate !== '');
                this.standardRate = storedTaxRateToPercentage(taxSplit[0]);
                this.taxInclusive = taxInfo.taxInclusive;
                taxSplit.splice(0, 1);
                this.userTaxItemList = taxSplit;
                for (var i = 0; i < this.userTaxItemList.length; i++) {
                    this.userTaxItemList[i] = storedTaxRateToPercentage(this.userTaxItemList[i])
                }
                this.createOrUpdate = 2;
                this.taxDialogInitialSnapshot = this.taxDialogSnapshot();
                this.dialogOpen = true
            },
            //增加rate
            addRate() {
                this.userTaxItemList.push("")
            },
            //增加Tax
            addTax() {
                this.taxInfoName = "";
                this.taxInclusive = 0;
                this.standardRate = "";
                this.userTaxItemList = [];
                this.createOrUpdate = 1;
                this.taxDialogInitialSnapshot = this.taxDialogSnapshot();
                this.dialogOpen = true
            },
            taxDialogSnapshot() {
                return JSON.stringify({
                    name: this.taxInfoName,
                    standardRate: this.standardRate,
                    additionalRates: this.userTaxItemList,
                    inclusive: this.taxInclusive
                });
            },
            handleTaxDialogClose(done) {
                if (this.dialogSaveLoading) {
                    return;
                }
                if (!this.taxDialogDirty) {
                    if (typeof done === 'function') {
                        done();
                    } else {
                        this.dialogOpen = false;
                    }
                    return;
                }
                this.$confirm(this.$t('common.unsavedChangesMsg'), this.$t('common.saveChangesTitle'), {
                    confirmButtonText: this.$t('common.confirmSave'),
                    cancelButtonText: this.$t('common.discard'),
                    distinguishCancelAndClose: true,
                    type: 'warning'
                }).then(() => {
                    this.saveTaxInfo();
                }).catch((action) => {
                    if (action === 'cancel') {
                        if (typeof done === 'function') {
                            done();
                        } else {
                            this.dialogOpen = false;
                        }
                    }
                });
            },
            //删除rate
            deleteRate(index) {
                this.userTaxItemList.splice(index, 1);
            },
            formatTaxRateDisplay(rates) {
                let taxSplit = String(rates == null ? '' : rates)
                    .split("&&").filter(rate => rate !== '');
                let visibleRateList = taxSplit.slice(0, 3).map(rate => {
                    return storedTaxRateToPercentage(rate) + "%";
                });
                let hiddenRateCount = taxSplit.length - visibleRateList.length;
                if (hiddenRateCount > 0) {
                    visibleRateList.push(hiddenRateCount + (hiddenRateCount === 1 ? this.$t('setting.moreRate') : this.$t('setting.moreRates')));
                }
                return visibleRateList.join(", ");
            },

            //删除tax
            async deleteTax() {
                if (!this.initialDataLoaded || this.deleteTaxLoading) {
                    return;
                }
                this.deleteTaxLoading = true;
                try {
                    const response = await this.$axios.post('update_tax_info', {
                        params: {
                            accessDate: timest(),
                            innerUUID: this.prepareDeleteTaxUUID,
                            syncStatus: 1
                        }
                    });
                    if (response.data.errorCode !== 0) {
                        throw new Error('Tax delete failed');
                    }
                    await this.queryUserTaxInfoList();
                    this.deleteTaxDialog = false;
                } catch {
                    this.$message.error(this.$t('common.systemError'));
                } finally {
                    this.deleteTaxLoading = false;
                }
            },

            //准备删除删除tax
            prepareDeleteTax(innerUUID) {
                this.deleteTaxDialog = true;
                this.prepareDeleteTaxUUID = innerUUID;
            },

            ///////////////////////保存/update开始///////////////////////
            async saveTaxInfo() {
                if (!this.initialDataLoaded || this.dialogSaveLoading) {
                    return false;
                }
                const taxName = this.taxInfoName.trim();
                if (taxName === '') {
                    this.$message.error(this.$t('setting.taxNameRequired'));
                    return false;
                }
                let rateList;
                try {
                    rateList = [this.standardRate].concat(this.userTaxItemList).map(percentageToStoredTaxRate);
                } catch (error) {
                    this.$message.error(this.$t('setting.invalidTaxRate'));
                    return false;
                }
                if (new Set(rateList).size !== rateList.length) {
                    this.$message.error(this.$t('setting.duplicateTaxRate'));
                    return false;
                }
                const rateString = rateList.join('&&');
                this.taxInfoName = taxName;

                this.dialogSaveLoading = true;
                try {
                    let response;
                    if (this.createOrUpdate === 1) {
                        const createUUID = uuid(null, 37);
                        response = await this.$axios.post('create_tax_info', {
                            params: {
                                belongToSetting: 1,
                                innerUUID: createUUID,
                                createDate: timest(),
                                accessDate: timest(),
                                rates: rateString,
                                syncStatus: 0,
                                taxInclusive: this.taxInclusive,
                                taxName,
                                settingTaxInfoUUID: "",
                                settingUUID: this.userSetting.innerUUID,
                                accumulateTaxInfoUUIDArrayKey: "",
                                beAccumulateTaxInfoUUIDArrayKey: "",
                                webSettingTaxInfoUUID: createUUID + "," + this.userSetting.taxInfoUUIDArrayKey,
                                userSettingInnerUUID: this.userSetting.innerUUID
                            }
                        });
                    } else if (this.createOrUpdate === 2) {
                        response = await this.$axios.post('update_tax_info', {
                            params: {
                                accessDate: timest(),
                                innerUUID: this.innerUUID,
                                rates: rateString,
                                syncStatus: 0,
                                taxInclusive: this.taxInclusive,
                                taxName
                            }
                        });
                    } else {
                        throw new Error('Tax save mode is invalid');
                    }
                    if (response.data.errorCode !== 0) {
                        throw new Error('Tax save failed');
                    }
                    await this.queryUserTaxInfoList();
                    this.taxDialogInitialSnapshot = this.taxDialogSnapshot();
                    this.dialogOpen = false;
                    return true;
                } catch {
                    this.$message.error(this.$t('common.saveFailed'));
                    return false;
                } finally {
                    this.dialogSaveLoading = false;
                }
            },
            ///////////////////////保存结束///////////////////////
            updateWithholding(flag, next) {
                if (!this.initialDataLoaded || this.loading || !this.withholdingDirty) {
                    return;
                }
                const withholdingName = this.userSetting.withHoldingTaxName.trim();
                if (this.userSetting.withHoldingActive === 1 && withholdingName === '') {
                    this.$message.error(this.$t('setting.withholdingNameRequired'));
                    return;
                }
                let withholdingRate;
                try {
                    withholdingRate = percentageToStoredTaxRate(this.userSetting.withHoldingTaxRate);
                } catch (error) {
                    this.$message.error(this.$t('setting.invalidTaxRate'));
                    return;
                }
                this.userSetting.withHoldingTaxName = withholdingName;
                let self = this;
                this.loading = true;
                this.$axios.post('update_setting', {
                    params: {
                        innerUUID: this.userSetting.innerUUID,
                        companyUUID: this.userSetting.companyUUID,
                        accessDate: timest(),
                        withHoldingActive: self.userSetting.withHoldingActive,
                        withHoldingTaxName: withholdingName,
                        withHoldingTaxRate: withholdingRate
                    }
                }).then(response => {
                    if (response.data.errorCode == 0) {

                        this.$message.success({
                            message: this.$t('common.saveSuccess'),
                            center: true
                        });

                        let tempUserSetting = JSON.parse(localStorage.getItem('userSetting'));
                        tempUserSetting.withHoldingActive = this.userSetting.withHoldingActive;
                        tempUserSetting.withHoldingTaxName = withholdingName;
                        tempUserSetting.withHoldingTaxRate = withholdingRate;
                        replaceStoredSetting(tempUserSetting);
                        this.initialWithholdingSnapshot = this.withholdingSnapshot;


                        this.loading = false;
                        if (flag === 100) {
                            if (this.taxYearDirty) {
                                this.updateTaxYearStart(100, next);
                            } else if (typeof next === 'function') {
                                next();
                            }
                        }
                    } else {
                        this.$message.error({
                            message: this.$t('common.saveFailed'),
                            center: true
                        });
                        this.loading = false;
                    }

                }).catch(() => {
                    this.$message.error(this.$t('common.systemError'));
                    this.loading = false;
                })
            },
            setTaxYearStartFromSetting(taxYearStart) {
                const taxYearStartSeconds = Number(taxYearStart == null || taxYearStart === "" ? 0 : taxYearStart);
                let taxYearStartDate = new Date(taxYearStartSeconds * 1000);
                let month = taxYearStartDate.getMonth() + 1;
                let day = taxYearStartDate.getDate();
                this.taxYearStartMonth = month < 10 ? "0" + month : "" + month;
                this.taxYearStartDay = day < 10 ? "0" + day : "" + day;
            },
            changeTaxYearStartMonth() {
                let dayCount = new Date(2001, parseInt(this.taxYearStartMonth, 10), 0).getDate();
                if (parseInt(this.taxYearStartDay, 10) > dayCount) {
                    this.taxYearStartDay = "";
                }
            },
            updateTaxYearStart(flag, next) {
                if (!this.initialDataLoaded || this.loading || !this.taxYearDirty) {
                    return;
                }
                if (this.taxYearStartMonth === "" || this.taxYearStartDay === "") {
                    this.$message.error(this.$t('setting.monthAndDayRequired'));
                    return;
                }
                let taxYearStart = Math.floor(new Date(2001, parseInt(this.taxYearStartMonth, 10) - 1, parseInt(this.taxYearStartDay, 10), 0, 0, 0).getTime() / 1000);
                this.loading = true;
                this.$axios.post('update_setting', {
                    params: {
                        innerUUID: this.userSetting.innerUUID,
                        companyUUID: this.userSetting.companyUUID,
                        accessDate: timest(),
                        taxYearStart: taxYearStart
                    }
                }).then(response => {
                    if (response.data.errorCode === 0) {
                        this.userSetting.taxYearStart = taxYearStart;
                        let tempUserSetting = JSON.parse(localStorage.getItem('userSetting'));
                        tempUserSetting.taxYearStart = taxYearStart;
                        replaceStoredSetting(tempUserSetting);
                        this.initialTaxYearSnapshot = this.taxYearSnapshot;
                        this.$message.success({
                            message: this.$t('common.saveSuccess'),
                            center: true
                        });
                        this.loading = false;
                        if (flag === 100 && typeof next === 'function') {
                            next();
                        }
                    } else {
                        this.$message.error(this.$t('common.saveFailed'));
                        this.loading = false;
                    }
                }).catch(() => {
                    this.$message.error(this.$t('common.systemError'));
                    this.loading = false;
                })
            },

            //查询taxInfo列表
            queryUserTaxInfoList() {
                return this.$axios.post('query_tax_info_list_user_web', {
                    params: {
                        "currentPage": this.currentPage,
                        "pageSize": this.pageSize,
                        "delStatus": 0,
                        "invoiceTaxOrNot": 1,
                        "companyUUID": this.company.innerUUID
                    }
                }).then(response => {
                    if (response.data.errorCode !== 0) {
                        throw new Error(response.data.errorMsg);
                    }
                    const taxList = Array.isArray(response.data.dataList) ? response.data.dataList : [];
                    for (let i = 0; i < taxList.length; i++) {
                        taxList[i].firstRate = this.formatTaxRateDisplay(taxList[i].rates);
                    }
                    this.userTaxInfoList = taxList;
                    this.totalCount = response.data.totalCount;
                });
            },
            queryUserSetting() {
                return this.$axios.post('query_setting_and_company', {
                    params: {}
                }).then(response => {
                    if (response.data.errorCode !== 0) {
                        throw new Error('Setting query failed');
                    }
                    const selectedData = syncCompanySelection(response.data);
                    if (selectedData == null) {
                        throw new Error('Selected company data is missing');
                    }
                    this.company = selectedData.company;
                    this.userSetting = selectedData.setting;
                    this.userSetting.withHoldingTaxRate = storedTaxRateToPercentage(this.userSetting.withHoldingTaxRate);
                    this.setTaxYearStartFromSetting(this.userSetting.taxYearStart);
                    this.initialWithholdingSnapshot = this.withholdingSnapshot;
                    this.initialTaxYearSnapshot = this.taxYearSnapshot;
                });
            },
            async loadInitialData() {
                this.loading = true;
                this.initialDataLoaded = false;
                this.loadError = '';
                try {
                    await this.queryUserSetting();
                    await this.queryUserTaxInfoList();
                    this.initialDataLoaded = true;
                } catch {
                    this.loadError = this.$t('common.loadFailed');
                } finally {
                    this.loading = false;
                }
            }
        },
        computed: {
            withholdingSnapshot() {
                return JSON.stringify({
                    active: this.userSetting.withHoldingActive,
                    name: this.userSetting.withHoldingTaxName,
                    rate: this.userSetting.withHoldingTaxRate
                });
            },
            withholdingDirty() {
                return this.initialWithholdingSnapshot !== ''
                    && this.withholdingSnapshot !== this.initialWithholdingSnapshot;
            },
            taxYearSnapshot() {
                return JSON.stringify({
                    month: this.taxYearStartMonth,
                    day: this.taxYearStartDay
                });
            },
            taxYearDirty() {
                return this.initialTaxYearSnapshot !== ''
                    && this.taxYearSnapshot !== this.initialTaxYearSnapshot;
            },
            monthOptions() {
                let monthList = [];
                for (let i = 1; i <= 12; i++) {
                    let month = i < 10 ? "0" + i : "" + i;
                    monthList.push({
                        label: month,
                        value: month
                    });
                }
                return monthList;
            },
            dayOptions() {
                let dayList = [];
                let dayCount = new Date(2001, parseInt(this.taxYearStartMonth, 10), 0).getDate();
                for (let i = 1; i <= dayCount; i++) {
                    let day = i < 10 ? "0" + i : "" + i;
                    dayList.push({
                        label: day,
                        value: day
                    });
                }
                return dayList;
            },
            taxDialogDirty() {
                return this.taxDialogInitialSnapshot !== ''
                    && this.taxDialogSnapshot() !== this.taxDialogInitialSnapshot;
            }
        },
        data() {
            return {
                dialogOpen: false,
                userTaxInfoList: [],
                userTaxItemList: [],
                checked: true,
                taxInfoName: "",
                standardRate: 0,
                taxId: 0,
                innerUUID: "",
                taxInclusive: 0,
                account: 0,
                //1.create,2.update
                createOrUpdate: 1,
                loading: true,
                initialDataLoaded: false,
                loadError: '',
                dialogSaveLoading: false,
                inclusiveStatus: false,
                exclusiveStatus: false,
                currentPage: 1,
                totalCount: 0,
                pageSize: 50,
                withholdingStatus: false,
                company: null,
                userSetting: {},
                deleteTaxDialog: false,
                prepareDeleteTaxUUID: "",
                cantOpenDetail: false,
                taxYearStartMonth: "",
                taxYearStartDay: "",
                deleteTaxLoading: false,
                initialWithholdingSnapshot: '',
                initialTaxYearSnapshot: '',
                taxDialogInitialSnapshot: ''
            }
        },
        mounted() {
            this.loadInitialData();
        },
        beforeRouteLeave(to, from, next) {
            if (!this.withholdingDirty && !this.taxYearDirty && !(this.dialogOpen && this.taxDialogDirty)) {
                next();
                return;
            }
            next(false);
            this.$confirm(this.$t('common.unsavedChangesMsg'), this.$t('common.saveChangesTitle'), {
                confirmButtonText: this.$t('common.confirmSave'),
                cancelButtonText: this.$t('common.discard'),
                distinguishCancelAndClose: true,
                type: 'warning'
            }).then(() => {
                if (this.dialogOpen && this.taxDialogDirty) {
                    this.saveTaxInfo().then(saved => {
                        if (!saved) {
                            return;
                        }
                        if (this.withholdingDirty) {
                            this.updateWithholding(100, next);
                        } else if (this.taxYearDirty) {
                            this.updateTaxYearStart(100, next);
                        } else {
                            next();
                        }
                    });
                } else if (this.withholdingDirty) {
                    this.updateWithholding(100, next);
                } else if (this.taxYearDirty) {
                    this.updateTaxYearStart(100, next);
                }
            }).catch((action) => {
                if (action === 'cancel') {
                    next();
                }
            });
        }
    }
</script>
<style scoped>
    .setting-initial-loading {
        min-height: 240px;
    }

    /deep/ .el-header {
        background-color: #f7f7f9;
        font-size: 25px;
        font-weight: 700;
        height: 100px !important;
        display: flex;
        justify-content: space-between;
        padding: 30px;
    }

    /deep/ .el-input__inner {
        width: 60%;
        margin-left: 2%;
        border-style: none none solid none;
        background-color: #ffffff;
        border-radius: 0px;
    }

    .taxListButton {
        border-style: none none solid none;
        background-color: white;
        border-radius: 0px;
        flex: 1 1 auto;
        width: auto;
        min-width: 0;
        height: auto;
        min-height: 40px;
        text-align: left;
        white-space: normal;
        overflow-wrap: anywhere;
        line-height: 20px;
    }

    .taxItemList {
        margin-bottom: 10px;
    }

    .taxItemList >>> .el-form-item__content {
        display: flex;
        align-items: flex-start;
        gap: 12px;
    }

    .tax-delete-button {
        flex: 0 0 auto;
        margin-left: 0 !important;
        color: red;
    }

    .taxListform {
        margin-top: 20px;
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 20px;
        align-items: start;
    }

    .taxes-card {
        grid-column: 2;
        grid-row: 1;
    }

    .tax-year-start-card {
        grid-column: 1;
        grid-row: 1;
    }

    .withholding-tax-card {
        grid-column: 1;
        grid-row: 2;
    }

    /deep/ .biaoti {
        font-size: 24px;
        padding-left: 1%;
    }

    /deep/ .margin_top_card {
        margin-top: 0;
    }

    /deep/ .el-switch {
        margin-left: 2%;
    }

    .taxListform >>> .el-form-item__label {
        position: relative;
        left: 1%;
        text-align: left;
    }

    .tax-year-subtitle {
        margin: 0 0 18px 1%;
        color: #606266;
        font-size: 15px;
    }

    .tax-year-controls {
        display: grid;
        grid-template-columns: minmax(0, 210px) minmax(0, 210px);
        column-gap: 72px;
        width: auto;
        margin-left: 1%;
    }

    .tax-year-controls >>> .el-form-item {
        display: flex;
        align-items: center;
        margin-bottom: 18px;
    }

    .tax-year-controls >>> .el-form-item__label {
        width: auto !important;
        min-width: 58px;
        padding-right: 12px;
        left: 0;
    }

    .tax-year-controls >>> .el-form-item__content {
        flex: 1;
        margin-left: 0 !important;
    }

    .tax-year-controls >>> .el-select,
    .tax-year-controls >>> .el-input {
        width: 100%;
    }

    .tax-year-controls >>> .el-input__inner {
        width: 100%;
        margin-left: 0;
    }

    @media (max-width: 900px) {
        .taxListform {
            grid-template-columns: minmax(0, 1fr);
        }

        .taxes-card,
        .tax-year-start-card,
        .withholding-tax-card {
            grid-column: 1;
        }

        .taxes-card {
            grid-row: 2;
        }

        .tax-year-start-card {
            grid-row: 1;
        }

        .withholding-tax-card {
            grid-row: 3;
        }
    }

    @media (max-width: 640px) {
        /deep/ .el-header {
            height: 86px !important;
            padding: 28px 72px 20px 20px;
        }

        /deep/ .el-main {
            padding: 12px;
        }

        .taxListform {
            margin-top: 8px;
            gap: 14px;
        }

        .taxListform >>> .el-form-item {
            display: block;
        }

        .taxListform >>> .el-form-item__label {
            float: none;
            width: 100% !important;
            line-height: 24px;
        }

        .taxListform >>> .el-form-item__content {
            margin-left: 0 !important;
        }

        .taxListform >>> .el-input__inner {
            width: 100%;
            margin-left: 0;
        }

        .tax-year-controls {
            grid-template-columns: minmax(0, 1fr);
            column-gap: 0;
            margin-left: 0;
        }

        .tax-year-controls >>> .el-form-item {
            display: flex;
        }

        .tax-year-controls >>> .el-form-item__label {
            float: left;
            width: auto !important;
        }
    }
</style>

<style>
    .el-button--success {
        background-color: #0D7DF7;
        border-color: #0D7DF7;
    }

    .el-button--success:focus, .el-button--success:hover {
        background-color: #0D7DF7;
        border-color: #0D7DF7;
    }

    @media (max-width: 640px) {
        .setting-dialog {
            width: calc(100vw - 24px) !important;
            max-width: calc(100vw - 24px) !important;
            margin-top: 12px !important;
        }

        .setting-dialog .el-form-item__label {
            float: none;
            width: 100% !important;
            padding-right: 0;
            text-align: left;
        }

        .setting-dialog .el-form-item__content {
            margin-left: 0 !important;
        }
    }
</style>
